export default 	[
    {
        path: '/term_files',
        name: 'term_files',
        component: () => import(
        /* webpackChunkName: "users" */ './../views/TermFiles/List'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/term_files/add',
        name: 'term_files_add',
        component: () => import(
            /* webpackChunkName: "courses-add" */ './../views/TermFiles/Add.vue'
        ),
        meta: {
            requiresAuth: true
        }
    },
]
